module.exports = __webpack_public_path__ + "img/hzfp3.2eba58c1.png";